import output from "_src/engine/output.js";

export default {

  _is_webgl2 : false,

  getContext(canvas = null, params) {
    
    let gl = null;

    gl = canvas.getContext("webgl2", params);

    if (!gl) {

      gl = canvas.getContext("webgl", params)
            || canvas.getContext("experimental-webgl", params);

      if (!gl) {
        return null;
      }

      output.log("WebGL 1.0 initialized", output.BLUE);

    } else {

      this._is_webgl2 = true;

      output.log("WebGL 2.0 initialized", output.BLUE);

    }

    return gl;

  },

  checkWebGL2() {
    return this._is_webgl2;
  }

}
